import { render } from "./ShippingReceive.vue?vue&type=template&id=77bae422&scoped=true"
import script from "./ShippingReceive.vue?vue&type=script&lang=js"
export * from "./ShippingReceive.vue?vue&type=script&lang=js"

import "./ShippingReceive.vue?vue&type=style&index=0&id=77bae422&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77bae422"]])

export default __exports__